import { Component, OnInit } from '@angular/core';
import { StockService } from 'src/app/services/stock/stock.service';
import { ColDef } from 'ag-grid-community';

@Component({
  selector: 'app-stock-at-cfs-ug',
  templateUrl: './stock-at-cfs-ug.component.html',
  styleUrls: ['./stock-at-cfs-ug.component.css']
})
export class StockAtCfsUgComponent implements OnInit{
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  vehicles: any[] = [];
  public isInProgress: boolean = false;

    // Column Definitions: Defines the columns to be displayed.
  colDefs: ColDef[] = [
    { field: "bl_no", headerName: "B/L No", filter: true },
    { field: "make", filter: true },
    { field: "model",filter: true },
    { field: "chassis_no",
      headerName: "Chassis No",
      filter: true,
      cellRenderer: (params: any) => {
        if (!params.value) return "";
        return `<a href="/view-vehicle-details/${params.data.vehicle_id}" target="_blank">${params.value}</a>`;
      }
    },
    { field: "engine_no", headerName: "Engine No", filter: true },
    { field: "engine_cc", headerName: "Engine CC", valueFormatter: this.numberFormatter, filter: "agNumberColumnFilter" },
    { field: "transm", headerName: "Transmission", filter: true },
    { field: "body_type", headerName: "Body Type", filter: true },
    { field: "drive", filter: true },
    { field: "fuel", filter: true },
    { field: "mileage", headerName: "Mileage", valueFormatter: this.numberFormatter, filter: "agNumberColumnFilter" },
    { field: "colour", filter: true },
    { field: "month_yr", headerName: "Month/Year", filter: true },
    { field: "vessel", headerName: "Vessel", filter: true },
    { field: "cfs_name", headerName: "CFS", filter: true },
    { field: "agency", headerName: "Agency", filter: true }
  ];

  ngOnInit(): void {
    this.isInProgress=true;
    this.fetchStockAtCFSUg();
  }

  constructor(
    private stockService:StockService,
  ){}

  fetchStockAtCFSUg():void{
    this.stockService.getStockAtCFSUg()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.isInProgress=false;
          this.errorMessage=null;
        }else if(response.status==='no_data'){
            this.errorMessage=response.message;
            this.isInProgress=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isInProgress=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isInProgress=false;
      }
    });
  }

  numberFormatter(params: any): string {
    if (params.value == null || params.value === '') return '';
    return new Intl.NumberFormat('en-UG').format(params.value);
  }
}
